/**
 * @desc 委托方发起终止
 */
import { AuctionHaltApplyForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ApplyAuctionHaltParameter = AuctionHaltApplyForm

const method = 'POST'
const url = '/trade/member/auction/halt/apply'

export const applyAuctionHaltApi = (
  params?: ApplyAuctionHaltParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

applyAuctionHaltApi.method = method
applyAuctionHaltApi.url = url
